import React, {useState, useRef, useEffect, useContext, useMemo} from "react";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import * as ROUTES from "../../../common/routes";
import {isNotProduction, useI18N, useLocation} from "../../../common/common";
import {DEV_ENV, LOCAL, STAGE_ENV, MARKET_PLACE_ONBOARD_POPOVER_SHOWN} from "../../../common/constant";
import CustomButton from "../../widget/button/CustomButton";
import Popover from "@material-ui/core/Popover";
import Grid from "@material-ui/core/Grid";
import {useKeycloakFunctions} from "../../../hooks/useKeycloakFunctions";
import AdminButton from "../../widget/button/AdminButton";
import {useBreakpoints, useLocalStorage} from "../../../hooks";
import StreamlineIcon from "../../widget/streamline-icon/StreamlineIcon";
import NavigationMenu from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/menu/navigation-menu.svg";
import SymbolEqual from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/mathematics/symbol-equal.svg";
import SingleNeutralCircle from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/users/geomertic-close-up-single-user-neutral/single-neutral-circle.svg";
import ArrowDown1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-down-1.svg";
import ArrowUp1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-up-1.svg";
import {toTitleCase} from "../../../common/string";
import {useHelpSection} from "../../../hooks/useHelpSection";
import PropTypes from "prop-types";
import {hexToRgb} from "../../../common/theme";
import {
    checkYearEndProcessing,
    showMarketplaceOnMenuV2,
    hideCooperationNavigationMenuBtn,
    checkInviteFriendReferralDisabled,
    checkDocumentsForTrialsAndProspectsDisabled,
} from "../../../common/configcat/functions";
import clsx from "clsx";
import LanguageSelect from "../../widget/select/languageSelect/LanguageSelect";
import CurrencySelect from "../../widget/select/currencySelect/CurrencySelect";
import Baggage from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/travel/baggage/baggage.svg";
import ReceiptSlip from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/shopping-ecommerce/receipts/receipt-slip-1.svg";
import SingleNeutral from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/users/geomertic-close-up-single-user-neutral/single-neutral.svg";
import CommonFileText from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/files-folders/common-files/common-file-text.svg";
import ShopLike from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/shopping-ecommerce/shops/shop-like.svg";
import Logout from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/login-logout/logout-1.svg";
import TravelManLugagge from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/travel/travel-metaphor/travel-man-luggage.svg";
import HeaderProfileMenu from "./HeaderProfileMenu";
import CloseIcon from "../../widget/streamline-icon/CloseIcon";
import HeaderPopoverTutorial from "./HeaderPopoverTutorial";
import TutorialStepperDialog from "../../dialog/marketplace/tutorialStepper/TutorialStepperDialog";
import {CurrencyContext} from "../../../store/providers/CurrencyProvider";
import {cloneDeep} from "lodash";
import {Link, Box} from "@material-ui/core";
import {NavLink} from "react-router-dom";
import {useLocalizedUrl} from "../../../common/common";
import {withSnackbar} from "../../hoc/SnackbarHOC";
import {useAnalytics} from "../../../store/providers/AnalyticsProvider";
import HeaderResortsMenu from "./HeaderResortsMenu";
import HeaderProfileMenuResortList from "./HeaderProfileMenuResortList";
import HapimagLogo from "../../widget/logo/HapimagLogo";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    title: {
        color: theme.palette.secondary.main,
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
    },
    version: {
        marginLeft: theme.spacing(1)
    },
    signInButton: {
        borderRadius: theme.spacing(0.5),
        color: theme.palette.secondary.main,
        "&:hover": {
            backgroundColor: theme.palette.secondary["100"]
        },
        height: theme.spacing(5.2),
        textTransform: "uppercase",
        left: theme.spacing(0)
    },
    logo: {
        height: theme.spacing(1.5),
        paddingLeft: theme.spacing(1),
        [theme.breakpoints.up("md")]: {
            height: theme.spacing(2.2),
            paddingLeft: theme.spacing(3)
        },
        cursor: "pointer"
    },
    userIcon: {
        fontSize: "22.5px !important"
    },
    arrowIcon: {
        width: theme.spacing(1.5),
        lineHeight: "22.5px",
        marginLeft: theme.spacing(0.9)
    },
    toolBar: {
        minHeight: theme.spacing(6),
    },
    svg: {
        fill: "none",
        marginRight: theme.spacing(1)
    },
    adminButton: {
        marginLeft: 28
    },
    mt1: {
        marginTop: theme.spacing(1)
    },
    mt2: {
        marginTop: theme.spacing(2)
    },
    popover: {
        minWidth: "375px",
        borderRadius: theme.spacing(1),
    },
    popoverMobile: {
        backgroundColor: theme.palette.secondary["50"],
        left: "0! important",
        width: "100%",
        maxWidth: "100%",
        position: "relative",
        boxShadow: "none",
        height: "100%",
        marginTop: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
    },
    popoverPaperRoot: {
        background: "#E7F2FB",
        top: "0! important",
        width: "100%",
        maxWidth: "100%",
        borderRadius: 0,
        position: "relative",
        [theme.breakpoints.up("sm")]: {
            borderRadius: "18px",
            top: "5px !important",
            width: "fit-content"
        },
        [theme.breakpoints.down("sm")]: {
            left: "0! important",
        }
    },
    popoverPaperContainer: {
        padding: theme.spacing(3, 2),
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(3)
        }
    },
    showPopoverButton: {
        borderRadius: theme.spacing(3),
        border: "1px solid " + theme.palette.secondary["900"],
        color: theme.palette.secondary["900"],
        paddingLeft: "15px",
        paddingRight: "15px",
        "&:hover": {
            borderRadius: theme.spacing(3),
            backgroundColor: "#E8E6E3 !important"
        },
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        }
    },
    mb2: {
        marginBottom: theme.spacing(2)
    },
    widthFitContent: {
        width: "fit-content"
    },
    vl: {
        borderLeft: "1px solid",
        borderColor: theme.palette.grey[100],
        height: theme.spacing(4),
        marginLeft: theme.spacing(1),
    },
    mr3: {
        marginRight: theme.spacing(3),
    },
    mt4: {
        marginTop: theme.spacing(4)
    },
    profileMenuItem: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    profileMenuItemIconSmall: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    profileDialog: {
        top: theme.spacing(6),
        bottom: theme.spacing(0),
        backgroundColor: theme.palette.secondary["50"],
        boxShadow: "none"
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    centerNavigation: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    rightItems: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    leftItems: {
        display: "flex",
        alignItems: "center",
    },
    navigationLink: {
        ...theme.typography.overline,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textMedium),
        textDecoration: "none",
        "&:hover": {
            color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh),
            cursor: "pointer",
            textDecoration: "underline"
        },
    },
    navigationButtonText: {
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textMedium) + "!important",
        textDecoration: "none !important",
        fontWeight: "bold !important",
        "&:hover": {
            color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh) + "!important",

        }
    },
    signInLink: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        whiteSpace: "nowrap",
        "&:hover": {
            color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh),
            cursor: "pointer",
        },
        ":active": {
            color: theme.palette.primary.main
        }
    },
    linkWrapper: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        "&:hover": {
            display: "inline-flex",
            minWidth: "max-content",
        }
    },
    activeLink: {
        color: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.main,
            cursor: "pointer",
            textDecoration: "none"
        }
    }
}));

const HeaderComponent = ({openPopover, showSnackbar}) => {

    const classes = useStyles();
    const {i18n} = useI18N();
    const {isExtraSmallScreen, isSmallScreen} = useBreakpoints();
    const {navigate, isRouteInLocation, getComposePagePath} = useLocation();
    const {
        initialized,
        authenticated,
        tokenParsed,
        login,
        logout,
        isAdmin,
        isProspect,
        isTrialMember,
        isMember,
    } = useKeycloakFunctions();
    const {getHelpUrl} = useHelpSection();
    const {getLocalizedUrl} = useLocalizedUrl();
    const [marketplaceTutorialPopoverShown, setMarketplaceTutorialPopoverShown] = useLocalStorage(MARKET_PLACE_ONBOARD_POPOVER_SHOWN);
    const {sendCustomEvent, eventNames} = useAnalytics();

    const [resortsMenuAnchorEl, setResortsMenuAnchorEl] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElAuth, setAnchorElAuth] = useState(null);
    const [marketplaceTutorialOpen, setMarketplaceTutorialOpen] = useState(false);
    const [marketplaceTutorialPopoverShowTimeout, setMarketplaceTutorialPopoverShowTimeout] = useState(null);
    const [openMarketplaceTutorialDialog, setOpenMarketplaceTutorialDialog] = useState(false);
    const [profileMenuItems, setProfileMenuItems] = useState([]);

    // Show marketplace feature Flag
    const [displayMarketplaceV2, setDisplayMarketplaceV2] = useState(null);
    const [abTestData, setAbTestData] = useState({});

    const [displayCooperationBtn, setDisplayCooperationBtn] = useState(null);

    const [currencyState] = useContext(CurrencyContext);
    const {currency} = currencyState;

    const marketplaceTutorialButtonRef = useRef(null);

    const [isInviteFriendReferralDisabled, setIsInviteFriendReferralDisabled] = useState(true);

    const [isDocumentsSectionDisabled, setDocumentsSectionDisabled] = useState(false);

    useEffect(() => {
        if(isMember()) {
            hideCooperationNavigationMenuBtn().then((value) => {
                setDisplayCooperationBtn(!value);
            });
        }

        if (isProspect() || isTrialMember()) {
            checkDocumentsForTrialsAndProspectsDisabled(tokenParsed?.preferred_username).then(value => {
                setDocumentsSectionDisabled(value);
            });
        }

        showMarketplaceOnMenuV2(tokenParsed?.preferred_username).then((value) => {
            setDisplayMarketplaceV2(value);
        });

        checkInviteFriendReferralDisabled(tokenParsed?.preferred_username).then(val => setIsInviteFriendReferralDisabled(val));
    }, [tokenParsed]);

    useEffect(() => {
        if (displayMarketplaceV2 !== null) {
            const data = {
                abtest_id: "GN_showMarketplaceOnMenuV2_20242008",
                abtest_name: "Show Marketplace on menu",
                abtest_variation_id: displayMarketplaceV2 ? "variant2" : "variant1",
                abtest_variation_name: displayMarketplaceV2 ? "Variant 2" : "Variant 1"
            };

            setAbTestData({
                ...data
            });
        }
    }, [displayMarketplaceV2]);

    useEffect(() => {
        if (initialized) {
            handleGA4SidemenuToggleTracking(!!anchorElAuth);
        }
    }, [anchorElAuth]);

    useEffect(() => {
        if (initialized) {
            setProfileMenuItems([
                {id: "holidays", label: i18n("common.label.holidays"), icon: <Baggage />, onClick: () => handleNavigate(isAdmin() ? ROUTES.RESERVATIONS_MANAGE : ROUTES.RESERVATIONS_UPCOMING, "My Holidays", "sidemenu"), align: "top", isVisible: authenticated && !isProspect(), variant: "primary"},
                {id: "points_shares", label: i18n("view.profile.shares_points.title"), icon: <ReceiptSlip />, onClick: () => handleNavigate(ROUTES.POINTS_SHARES_POINTS), align: "top", isVisible: authenticated && !isTrialMember(), variant: "primary"},
                {id: "account_settings", label: i18n("view.profile.account_settings.title"), icon: <SingleNeutral />, onClick: () => handleNavigate(ROUTES.PROFILE_ACCOUNT_SETTINGS, "Account Settings", "sidemenu"), align: "top", isVisible: authenticated, variant: "primary"},
                {id: "documents", label: i18n("view.profile.payment_files.title"), icon: <CommonFileText />, onClick: () => handleNavigate(ROUTES.USER_DOCUMENTS), align: "top", isVisible: authenticated && !isDocumentsSectionDisabled, variant: "primary"},
                {id: "invite_friend", label: i18n("common.label.invite_friend"), icon: <TravelManLugagge />, onClick: () => handleInviteFriendClick(), align: "top", isVisible: authenticated && !isInviteFriendReferralDisabled, variant: "primary", className: !displayMarketplaceV2 ? classes.mb2 : ""},
                {id: "marketplace", label: i18n(isTrialMember() ? "common.label.marketplace_trial" : "view.marketplace.market_place"), icon: <ShopLike />, onClick: () => handleNavigate(ROUTES.MARKET_PLACE_BUY), align: "top", isVisible: authenticated && displayMarketplaceV2, variant: "primary", className: classes.mb2},
                {id: "resorts", label: toTitleCase(i18n("common.label.resorts")), onClick: () => handleNavigate(ROUTES.RESORTS, "Resorts", "sidemenu"), align: "top", isVisible: (isSmallScreen() || isExtraSmallScreen()), divider: authenticated, variant: "secondary", className: classes.mt1, component: anchorElAuth ? <HeaderProfileMenuResortList /> : undefined },
                {id: "cooperation", label: toTitleCase(i18n("common.label.cooperation")), onClick: () => handleNavigate(getComposePagePath(ROUTES.PARTNERSHIPS), "Cooperation", "sidemenu"), align: "top", isVisible: ((isSmallScreen() || isExtraSmallScreen()) && displayCooperationBtn), variant: "secondary"},
                {id: "our_concept", label: toTitleCase(i18n("common.label.our_concept")), onClick: () => handleNavigate(getComposePagePath(ROUTES.CONCEPT), "Concept", "sidemenu"), align: "top", isVisible: (isSmallScreen() || isExtraSmallScreen()), variant: "secondary"},
                {id: "membership", label: toTitleCase(i18n("common.label.membership")), onClick: () => handleNavigate(getComposePagePath(ROUTES.MEMBERSHIP), "Membership", "sidemenu"), align: "top", isVisible: (isSmallScreen() || isExtraSmallScreen()), variant: "secondary"},
                {id: "help", label: i18n("common.label.help"), onClick: () => handleNavigateToHelp(), align: "top", isVisible: true, variant: "secondary", divider: !(isExtraSmallScreen() || isSmallScreen())},
                {id: "logout", label: i18n("common.label.logout"), icon: <Logout />, iconClass: classes.profileMenuItemIconSmall, iconSize: 20, onClick: () => handleClickSignOut(), divider: true, align: "bottom", isVisible: authenticated, variant: "secondary"}
            ]);
        }
    }, [initialized, anchorElAuth]);

    const isGuestOrProspectOrTrial = useMemo(() => {
        return (tokenParsed && (isProspect() || isTrialMember())) || !tokenParsed;
    }, [tokenParsed]);

    useEffect(() => {
        if(isGuestOrProspectOrTrial){
            const newItems = cloneDeep(profileMenuItems);
            newItems.splice(newItems.findIndex(val => val.id === "help"), 0, {id: "try_out_hapimag", label: toTitleCase(i18n("common.label.try_out_hapimag")), onClick: () => handleNavigate(getComposePagePath(ROUTES.TRY_OUT_HAPIMAG), "Try out", "sidemenu"), align: "top", isVisible: (isSmallScreen() || isExtraSmallScreen()), variant: "secondary"});
            setProfileMenuItems(newItems);
        }
    }, [isGuestOrProspectOrTrial]);

    useEffect(() => {
        if (!marketplaceTutorialPopoverShown) {
            if (openPopover) {

                const showTime = setTimeout(() => {
                    setMarketplaceTutorialOpen(false);
                }, 10000);

                setMarketplaceTutorialOpen(true);
                setMarketplaceTutorialPopoverShown(MARKET_PLACE_ONBOARD_POPOVER_SHOWN, true);
                setMarketplaceTutorialPopoverShowTimeout(showTime);

                return () => clearTimeout(showTime);
            }
        }
    }, [openPopover]);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClickPersonal = event => {
        setAnchorElAuth(event.currentTarget);
        if (isExtraSmallScreen()) {
            document.getElementById("header-toolbar-component").scrollIntoView();
        }
    };

    const handleClickSignIn = async () => {
        if(await checkYearEndProcessing()) {
            showSnackbar({
                type: "info",
                message: i18n("view.auth.label.sign_in_maintenance"),
                withIcon: true,
                closeIcon: true
            });
        } else {
            window.history.pushState(window.history.state, null, window.location.href);
            login();
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCloseAuth = () => {
        setAnchorElAuth(null);
        if (isExtraSmallScreen()) {
            window.scrollTo({top: 0});
        }
    };

    const handleClickSignOut = () => {
        sendCustomEvent({
            event_name: eventNames.LOGOUT,
            login_status: "false"
        });
        logout();
    };

    const handleNavigateToHelp = () => {
        handleGA4NavigationTracking("Help Centre", "sidemenu");
        setAnchorElAuth(false);
        window.open(getHelpUrl(), "_blank");
    };

    const handleMarketplaceTutorialPopoverClose = () => {
        setMarketplaceTutorialOpen(false);
        setMarketplaceTutorialPopoverShowTimeout(null);
        clearTimeout(marketplaceTutorialPopoverShowTimeout);
    };

    const handleLogoClick = () => {
        navigate(ROUTES.HOME);
    };

    const handleNavigate = (route, clickItem, navigationType) => {
        if (clickItem && navigationType) {
            handleGA4NavigationTracking(clickItem, navigationType);
        }
        setAnchorElAuth(false);
        navigate(route);
    };

    const handleClickMarketplaceTutorialDialogOpen = () => {
        setOpenMarketplaceTutorialDialog(true);
    };

    const handleClickMarketplaceTutorialDialogClose = () => {
        setOpenMarketplaceTutorialDialog(false);
    };

    const handleGA4NavigationTracking = (clickItem, navigationType) => {
        sendCustomEvent({
            event_name: eventNames.NAVIGATION,
            [eventNames.NAVIGATION]: {
                click_item: clickItem,
                navigation_type: navigationType
            }
        });
    };

    const handleGA4SidemenuToggleTracking = (toggle) => {
        sendCustomEvent({
            event_name: toggle ? eventNames.SIDEMENU_UNFOLD : eventNames.SIDEMENU_FOLD,
            ...abTestData
        });
    };

    const handleInviteFriendClick = () => {
        sendCustomEvent({
            event_name: eventNames.NAVIGATION,
            [eventNames.NAVIGATION]: {
                click_item: "Invite a Friend",
                referral_entry_point: "2-menu",
                navigation_type: "sidemenu"
            }
        });
        window.open(getHelpUrl("/referral-program", "rep2-menu"), "_blank");
    };

    return (
        <Toolbar
            className={classes.toolBar}
            id={"header-toolbar-component"}
        >
            <Grid
                container
                justify="space-between"
            >
                {/* Left header items */}
                <Grid
                    item
                    lg={3}
                    md={3}
                    sm={4}
                    xs={4}
                    className={classes.leftItems}
                >

                    {(location.host.includes(DEV_ENV) || location.host.includes(LOCAL)) && (
                        <>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                onClick={handleClick}
                                className={classes.signInButton}

                            >
                                <StreamlineIcon><NavigationMenu /></StreamlineIcon>
                            </IconButton>

                            <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={() => navigate(ROUTES.HOME)}>
                                    {"Home"}
                                </MenuItem>

                                <MenuItem onClick={() => navigate(ROUTES.BUTTONS)}>
                                    {"Buttons & Chips"}
                                </MenuItem>

                                <MenuItem onClick={() => navigate(ROUTES.INTL)}>
                                    {"Internationalization and Localization"}
                                </MenuItem>

                                <MenuItem onClick={() => navigate(ROUTES.MARKET_PLACE_BUY)}>
                                    {i18n("view.marketplace.market_place")}
                                </MenuItem>

                                <MenuItem onClick={() => navigate(ROUTES.VERSIONS)}>
                                    {"Versions"}
                                </MenuItem>

                            </Menu>
                        </>
                    )}

                    <HapimagLogo
                        classname={classes.logo}
                        onClick={handleLogoClick}
                    />

                    {isAdmin() &&
                        <AdminButton
                            testing={isNotProduction()}
                            classname={classes.adminButton}
                        />
                    }

                    <div className={classes.version}>
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            {!isExtraSmallScreen() && isNotProduction() &&
                                <Grid item>
                                    {location.host.includes(DEV_ENV) && "Development"}
                                    {location.host.includes(STAGE_ENV) && "Stage"}
                                    {process.env.APP_VERSION ? "v." + process.env.APP_VERSION : ""}
                                </Grid>
                            }
                        </Grid>
                    </div>
                </Grid>

                {/* Centered header items */}
                {!(isSmallScreen() || isExtraSmallScreen()) && !isRouteInLocation(ROUTES.ONLINE_ACCESS) &&
                    <Grid
                        item
                        lg={6}
                        md={6}
                        className={classes.centerNavigation}
                    >
                        <Box
                            className={classes.linkWrapper}
                        >
                            <Box
                                className={classes.navigationLink}
                                activeclassname={classes.activeLink}
                                onClick={(event) => {
                                    setResortsMenuAnchorEl(event.currentTarget);
                                    handleGA4NavigationTracking("Resorts", "header");
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 13 || event.keyCode === 32) {
                                        event.preventDefault();
                                        event.target.click();
                                    }
                                }}
                                tabIndex={0}
                            >
                                {i18n("common.label.resorts").toUpperCase()}
                            </Box>
                        </Box>

                        {displayCooperationBtn && (
                            <Box
                                className={classes.linkWrapper}
                            >
                                <NavLink
                                    to={getLocalizedUrl(getComposePagePath(ROUTES.PARTNERSHIPS))}
                                    className={classes.navigationLink}
                                    activeclassname={classes.activeLink}
                                    onClick={() => handleGA4NavigationTracking("Cooperation", "header")}
                                >
                                    {i18n("common.label.cooperation").toUpperCase()}
                                </NavLink>
                            </Box>
                        )}

                        <Box
                            className={classes.linkWrapper}
                        >
                            <NavLink
                                to={getLocalizedUrl(getComposePagePath(ROUTES.CONCEPT))}
                                className={classes.navigationLink}
                                activeclassname={classes.activeLink}
                                onClick={() => handleGA4NavigationTracking("Concept", "header")}
                            >
                                {i18n("common.label.our_concept").toUpperCase()}
                            </NavLink>
                        </Box>

                        <Box
                            className={classes.linkWrapper}
                        >
                            <NavLink
                                to={getLocalizedUrl(getComposePagePath(ROUTES.MEMBERSHIP))}
                                className={classes.navigationLink}
                                activeclassname={classes.activeLink}
                                onClick={() => handleGA4NavigationTracking("Membership", "header")}
                            >
                                {i18n("common.label.membership").toUpperCase()}
                            </NavLink>
                        </Box>


                        {isGuestOrProspectOrTrial &&
                            <Box
                                className={classes.linkWrapper}
                            >
                                <NavLink
                                    to={getLocalizedUrl(getComposePagePath(ROUTES.TRY_OUT_HAPIMAG))}
                                    className={classes.navigationLink}
                                    activeclassname={classes.activeLink}
                                    onClick={() => handleGA4NavigationTracking("Try out", "header")}
                                >
                                    {i18n("common.label.try_out_hapimag").toUpperCase()}
                                </NavLink>
                            </Box>
                        }
                    </Grid>
                }

                <HeaderResortsMenu
                    anchorEl={resortsMenuAnchorEl}
                    onCloseMenu={() => setResortsMenuAnchorEl(null)}
                />

                {/* Right header items*/}
                <Grid
                    item
                    lg={3}
                    md={3}
                    sm={8}
                    xs={8}
                    className={classes.rightItems}
                >

                    {isRouteInLocation(ROUTES.MARKET_PLACE) && isProspect() &&
                        <>
                            <CustomButton
                                buttonRef={marketplaceTutorialButtonRef}
                                className={classes.showPopoverButton}
                                disableRipple
                                size={"small"}
                                onClick={handleClickMarketplaceTutorialDialogOpen}
                            >
                                {i18n("view.header.marketplace_onboarding.popover_button")}
                            </CustomButton>

                            {openPopover &&
                                <Popover
                                    anchorReference={isExtraSmallScreen() ? "anchorPosition" : "anchorEl"}
                                    anchorPosition={{top: 0, left: 0}}
                                    open={marketplaceTutorialOpen}
                                    onClose={handleMarketplaceTutorialPopoverClose}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: isExtraSmallScreen() ? "left" : "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: isExtraSmallScreen() ? "left" : "right",
                                    }}
                                    anchorEl={marketplaceTutorialButtonRef.current}
                                    classes={{paper: classes.popoverPaperRoot}}
                                >
                                    <div className={classes.popoverPaperContainer}>
                                        <HeaderPopoverTutorial
                                            openDialog={handleClickMarketplaceTutorialDialogOpen}
                                        />
                                    </div>
                                </Popover>
                            }

                            <TutorialStepperDialog
                                open={openMarketplaceTutorialDialog}
                                onCloseTip={handleClickMarketplaceTutorialDialogClose}
                            />
                        </>
                    }

                    {!isExtraSmallScreen() && !isRouteInLocation(ROUTES.BOOKING) &&
                        <>
                            {!isRouteInLocation(ROUTES.MARKET_PLACE) && !isRouteInLocation(ROUTES.RESORTS_BOOKING_INFORMATION) && currency &&
                                <CurrencySelect
                                    type={"popover"}
                                    location={"header"}
                                />
                            }

                            <LanguageSelect
                                type={"popover"}
                                location={"header"}
                            />

                            <div className={classes.vl} />
                        </>
                    }

                    {authenticated ? (
                        <>
                            {!isExtraSmallScreen() ? (
                                <div
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={handleClickPersonal}
                                    className={classes.signInButton}
                                >
                                    <CustomButton
                                        className={classes.signInButton}
                                        size={"small"}
                                        endIcon={
                                            <>
                                                <StreamlineIcon
                                                    className={classes.userIcon}
                                                >
                                                    <SingleNeutralCircle />
                                                </StreamlineIcon>

                                                {anchorElAuth ? (
                                                    <StreamlineIcon
                                                        className={classes.arrowIcon}
                                                    >
                                                        <ArrowUp1 />
                                                    </StreamlineIcon>
                                                ) : (
                                                    <StreamlineIcon
                                                        className={classes.arrowIcon}
                                                    >
                                                        <ArrowDown1 />
                                                    </StreamlineIcon>
                                                )}
                                            </>
                                        }
                                    >
                                        {" "}
                                    </CustomButton>
                                </div>
                            ) : (
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={handleClickPersonal}
                                    className={clsx(classes.signInButton, classes.ml2)}
                                >
                                    {anchorElAuth ? (
                                        <CloseIcon />
                                    ) : (
                                        <StreamlineIcon>
                                            <SymbolEqual />
                                        </StreamlineIcon>
                                    )}
                                </IconButton>
                            )}
                        </>
                    ) : (
                        <>
                            {!(isExtraSmallScreen() || isSmallScreen()) ? (
                                <Link
                                    className={classes.signInLink}
                                    onClick={handleClickSignIn}
                                    onKeyDown={(event) => {
                                        if (event.keyCode === 13 || event.keyCode === 32) {
                                            event.preventDefault();
                                            event.target.click();
                                        }
                                    }}
                                    tabIndex={0}
                                >
                                    <Typography
                                        className={classes.navigationButtonText}
                                        variant={"overline"}
                                    >
                                        {i18n("view.auth.label.sign_in")}
                                    </Typography>
                                </Link>
                            ) : (
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={handleClickPersonal}
                                    className={clsx(classes.signInButton, classes.ml2)}
                                >
                                    {anchorElAuth ? (
                                        <CloseIcon />
                                    ) : (
                                        <StreamlineIcon>
                                            <SymbolEqual />
                                        </StreamlineIcon>
                                    )}
                                </IconButton>
                            )}
                        </>
                    )}

                    {initialized &&
                        <Popover
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            id="simple-menu"
                            anchorEl={anchorElAuth}
                            keepMounted
                            open={Boolean(anchorElAuth)}
                            onClose={handleCloseAuth}
                            classes={isExtraSmallScreen() ? {paper: classes.popoverMobile} : {paper: classes.popover}}
                        >
                            <HeaderProfileMenu
                                isOpen={Boolean(anchorElAuth)}
                                userFullName={tokenParsed?.name}
                                menuItems={profileMenuItems}
                            />
                        </Popover>
                    }
                </Grid>
            </Grid>
        </Toolbar>
    );
};

HeaderComponent.defaultProps = {
};

HeaderComponent.propTypes = {
    openPopover: PropTypes.any,
    showSnackbar: PropTypes.func
};

export default withSnackbar(HeaderComponent);
